
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/schedule-map",
      function () {
        return require("private-next-pages/embed/schedule-map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/schedule-map"])
      });
    }
  